const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the content host component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('adminTopNav', ['Application', 'Authorization', 'AccessHelper', function (Application, Authorization, AccessHelper) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      type: '@'
    },
    template: require('../../templates/directives/admin-top-nav.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.user = Authorization.getAuthToken() && Authorization.getAuthToken().user;
      if (!self.user) {
        Application.navigation.goToSignIn();
        return;
      }

      if (self.user.role !== 'admin' && self.user.role !== 'creator' && !self.user.is_collaborator) {
        Application.navigation.goTo('/explore');
        return;
      }

      self.features = Application.features.flags();
      self.options = {
        overview: AccessHelper.isAllowed(['admin', 'overview'], null, ['admin', 'creator']),
        users: AccessHelper.allowGeneralActivity('users', ['admin']),
        content: AccessHelper.allowGeneralActivity('content', ['admin', 'creator', 'collaborator']),
        workshops: self.features.workshops && AccessHelper.allowGeneralActivity('workshops', ['admin', 'creator', 'collaborator']),
        assessments: self.features.assessments && AccessHelper.allowGeneralActivity('assessments', ['admin', 'creator', 'collaborator']),
        assignments: AccessHelper.allowGeneralActivity('assignments', ['admin', 'creator']),
        workflows: AccessHelper.isAllowed(['admin', 'workflows'], null, ['admin', 'creator']),
        reports: self.features.reports && AccessHelper.isAllowed(['admin', 'reports'], null, ['admin']),
        badges: self.features.badges && AccessHelper.isAllowed(['admin', 'badges'], null, ['admin']),
        journeys: self.features.journeys && AccessHelper.allowGeneralActivity('journeys', ['admin', 'creator']),
        surveys: self.features.surveys && AccessHelper.isAllowed(['admin', 'surveys'], null, ['admin']),
        settings: AccessHelper.isAllowed(['admin', 'settings'], null, ['admin'])
      };

      self.isAdmin = function() {
        return self.user.role === 'admin';
      };

      self.isCollaborator = function() {
        return Authorization.isCollaborator();
      };
    }],
    controllerAs: 'nav'
  };
}]);
